import React, { useCallback, useRef, useState } from "react";
import { Button, Overlay, Popover } from "react-bootstrap";
import { stampOilRequestAsChoosingWinner } from "../../../services/turgoil-api";
import { useParams } from "react-router-dom";

type Props = {
  onSuccess: () => void;
  oilRequest: any;
};

const StampOilRequestAsChoosingWinner: React.FC<Props> = ({
  onSuccess,
  oilRequest,
}): React.ReactElement => {
  const buttonRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [comment, setComment] = useState("");
  const { id } = useParams();
  const [popoverOpen, setPopoverOpen] = useState(false);

  const stamp = () => {
    setLoading(true);
    stampOilRequestAsChoosingWinner(id, { comment })
      .then(() => {
        setComment("");
        setLoading(false);
        setPopoverOpen(false);
        onSuccess();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const togglePopover = useCallback(() => {
    setPopoverOpen(!popoverOpen);
  }, [popoverOpen]);

  if (oilRequest.status !== "Active") {
    return null;
  }

  return (
    <>
      <Button
        type="button"
        variant="secondary"
        onClick={togglePopover}
        ref={buttonRef}
      >
        Lõpeta
      </Button>

      <Overlay
        show={popoverOpen}
        onHide={togglePopover}
        target={buttonRef}
        rootClose
      >
        <Popover id="popover-basic">
          <Popover.Header as="h3">
            Kas olete kindel, et soovite hanke lõpetada enne lõppu?
          </Popover.Header>
          <Popover.Body>
            Juhul kui Teile on tehtud pakkumisi, siis hange liigub olekusse
            "Võitja valimine". Kui ei ole pakkumisi, siis liigub olekusse
            "Lõppenud".
          </Popover.Body>
          <div className="popover-footer">
            <Button type="button" variant="link" onClick={togglePopover}>
              Tühista
            </Button>
            <Button
              type="button"
              className="float-end"
              onClick={stamp}
            >
              Jah
            </Button>
          </div>
        </Popover>
      </Overlay>
    </>
  );
};

export default StampOilRequestAsChoosingWinner;
